import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, User, KeyRound } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { api } from "../lib/api";

const AdminLogin = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { token } = await api.login(username, password);
      localStorage.setItem("bf_admin_token", token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(t("admin_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden bg-[#0a0e1f]">
      <div className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(circle_at_50%_40%,#22d3ee_0%,transparent_55%)]" />
      <div className="relative bf-glass rounded-3xl p-8 md:p-10 w-full max-w-md bf-section-fade">
        <div className="flex flex-col items-center text-center mb-8">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#ff1e34] to-[#ff2d5e] flex items-center justify-center mb-5 shadow-[0_0_40px_-4px_rgba(255,30,52,0.7)]">
            <Lock className="w-9 h-9 text-white" />
          </div>
          <h1 className="text-3xl font-extrabold text-white mb-1">{t("admin_title")}</h1>
          <p className="text-gray-400 text-sm">{t("admin_subtitle")}</p>
        </div>

        {error && (
          <div className="mb-5 bg-red-500/10 border border-red-500/30 text-red-400 rounded-xl px-4 py-3 text-sm text-center">
            {error}
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="flex items-center gap-2 text-sm text-gray-300 mb-2">
              <User className="w-4 h-4 text-gray-400" /> {t("admin_user")}
            </label>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              className="bf-input w-full rounded-xl px-4 py-3 text-sm placeholder:text-gray-500"
            />
          </div>
          <div>
            <label className="flex items-center gap-2 text-sm text-gray-300 mb-2">
              <KeyRound className="w-4 h-4 text-gray-400" /> {t("admin_password")}
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="bf-input w-full rounded-xl px-4 py-3 text-sm placeholder:text-gray-500"
            />
          </div>
          <button type="submit" disabled={loading} className="bf-btn-primary text-white font-bold w-full py-3.5 rounded-xl uppercase tracking-wider text-sm disabled:opacity-60">
            {loading ? "..." : t("admin_enter")}
          </button>
        </form>

        <div className="mt-6 pt-6 border-t border-white/10 text-center">
          <Link to="/" className="text-[#67e8f9] text-sm font-medium hover:text-[#22d3ee] transition-colors">
            {t("admin_back")}
          </Link>
        </div>
        <p className="text-gray-600 text-xs text-center mt-4">Demo: admin / barbo2024</p>
      </div>
    </div>
  );
};

export default AdminLogin;
